<script>
	export default {
		name: 'PWAExecuter',
		data() { 
			return {
				deferredPrompt_: null
			}
		},
		methods: {
			beforeInstallPrompt(e) {
				const self_ = this;

				e.preventDefault(); // Prevent Chrome 67 and earlier from automatically showing the prompt

				const appState_ = self_.getState('app')
				const pwa_ = appState_.pwa;

				pwa_.deferredPrompt = e;

				const dialog_ = {
					title: 'Install App',
					text: 'Click ADD to install.',
					img: {
						url: require('~/assets/logo.png')
					},
					okButton: {
						title: 'ADD',
						link: {
							method: {
								name: 'installPWA'
							}
						}
					}
				}

				self_.setComponentState('informationDialog', dialog_)
				self_.setComponentState('showInformationDialog', true)
			},
			installPWA() {
				const self_ = this;

				const appState_ = self_.getState('app')
				const pwa_ = appState_.pwa;

				if (!self_.isFalse(pwa_.deferredPrompt) && self_.isFalse(pwa_.prompted)) {
					pwa_.prompted = true;

					pwa_.deferredPrompt.prompt() // show install prompt

					Promise.resolve().then(() => {
						return pwa_.deferredPrompt.userChoice
					}).then(result => {
						if (result.outcome == 'accepted') {
/* info */					self_.logInfo('PWA Installation', 'Mobile app is installed.')
						}
						pwa_.deferredPrompt = null;
					}).catch(error => {
/* error */				self_.logError('Error', 'installPWA()', error)
					})
				}
			}
		}
	}
</script>